export class AbstractStorage {
    constructor() {
        this.set = this.set.bind(this);
        this.get = this.get.bind(this);
        this.remove = this.remove.bind(this);
        this.clear = this.clear.bind(this);
        this.getAll = this.getAll.bind(this);
    }
    set(key, value) {
    };
    get(key) {
        return undefined;
    };
    remove(key) {
    };
    clear() {
    };
    getAll() {
    };
}


// WEBPACK FOOTER //
// ./src/storage/AbsctractStorage.js